var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganization = function SvgOrganization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4995 25.419L29.0697 37.5623C30.5438 38.3375 32.2215 38.7765 34 38.7765C35.7784 38.7765 37.456 38.3375 38.9303 37.5623L62.5005 25.419C64.1909 24.53 65.3437 22.7566 65.3437 20.714C65.3437 18.6713 64.1909 16.8979 62.5005 16.009L38.9303 3.86566C37.456 3.09044 35.7784 2.65149 34 2.65149C32.2215 2.65149 30.5438 3.09044 29.0697 3.86566L5.4995 16.009C3.80893 16.8979 2.65625 18.6713 2.65625 20.714C2.65625 22.7566 3.80893 24.53 5.4995 25.419Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 49.9551L29.0697 64.1248C30.544 64.9 32.2215 65.339 34 65.339C35.7785 65.339 37.456 64.9 38.9303 64.1248L65.3437 49.9551",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 36.6738L29.0697 50.8436C30.544 51.6188 32.2215 52.0577 34 52.0577C35.7785 52.0577 37.456 51.6188 38.9303 50.8436L65.3437 36.6738",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgOrganization;